// extracted by mini-css-extract-plugin
export default {"marginRightButton":"styles_marginRightButton__NIoEI"};